
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/it/guidelines",
      function () {
        return require("private-next-pages/it/guidelines.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/it/guidelines"])
      });
    }
  